<app-header></app-header>
<!-- <app-dashboard></app-dashboard> -->
<div class="overall-container">
  <!-- <app-scenario-creation></app-scenario-creation> -->
  <!-- <app-scenario-library></app-scenario-library> -->
  <app-loader [is_show_loader]="showLoader"></app-loader>
  <router-outlet></router-outlet>
</div>
